/**
 * Get the filename without the extension
 * @example testFilename.jpg => testFilename
 * @param filename string
 * @returns string
 */ const removeFileExtension = (filename)=>{
    return filename.replace(/\.[^.]*$/, '') || filename;
};

export { removeFileExtension };
//# sourceMappingURL=remove-file-extension.js.map
